@if (showLogin()) {
<div class="pbx-login" data-screen-label="Sign in">
  <section class="pbx-brand">
    <div class="pbx-brand__logo">
      <img src="/assets/images/logos/logo-probechmark.png" alt="ISG ProBenchmark" />
    </div>

    <div class="pbx-hero">
      <div class="pbx-hero__eyebrow">Benchmarking &amp; Price Intelligence</div>
      <h1 class="pbx-hero__title">Benchmark, price, <em>win</em></h1>
      <p class="pbx-hero__lead">
        One platform for real-time market intelligence, helping pricing, sourcing, and sales teams make data-driven decisions with confidence.
      </p>
    </div>

    <div class="pbx-brand__legal">
      <a href="https://isg-one.com/probenchmark-termsofuse" target="_blank" rel="noopener">Terms of use</a>
      © {{ todaysDate | date: 'yyyy' }} Information Services Group, Inc. All Rights Reserved.
    </div>
  </section>

  <section class="pbx-signin">
    <div class="pbx-signin__body">
      <div class="pbx-signin__stat">$200 billion</div>
      <p class="pbx-signin__stat-sub">ISG influenced technology spend annually.</p>

      <div class="pbx-signin__action">
        <button type="button" class="pbx-signin__btn" (click)="login()">Login</button>
      </div>

      @if (appname()) {
      <span class="pbx-signin__version">{{ appname() }} · v{{ buildversion() }}</span>
      }
    </div>
  </section>
</div>
}
 @else {
<div class="pbx-signing-in" role="status" aria-live="polite">
  <h2 class="pbx-signing-in__title">Signing In...</h2>
  <p class="pbx-signing-in__sub">Please wait while we set up your session</p>
  <div class="pbx-signing-in__spinner" aria-hidden="true"></div>
</div>
}
